import { render, staticRenderFns } from "./orgPersonTable.vue?vue&type=template&id=2e0b53a0&scoped=true"
import script from "./orgPersonTable.vue?vue&type=script&lang=js"
export * from "./orgPersonTable.vue?vue&type=script&lang=js"
import style0 from "./orgPersonTable.vue?vue&type=style&index=0&id=2e0b53a0&prod&lang=scss"
import style1 from "./orgPersonTable.vue?vue&type=style&index=1&id=2e0b53a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b53a0",
  null
  
)

export default component.exports